/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
   export class CustomDivService {
       private divCounter:any = {};
       private divHandler: any = {};

       constructor() {
           
       }

       public divLoaded(stepId: string) {
           if (!this.divCounter[stepId]) {
               this.divCounter[stepId] = 0;
           }

           this.divCounter[stepId]++;

           if (this.divHandler[stepId]) {
               this.divHandler[stepId].forEach(c => {
                   c(this.divCounter[stepId]);
               });
           }
       }

       public resetCounter() {
           this.divCounter={};
       }

       public registerDivLoadedHandler(stepId: string, callback: any) {
           if (!this.divHandler[stepId]) {
               this.divHandler[stepId] = [];
           }

           this.divHandler[stepId].push(callback);
       }

       public unregisterDivLoadedHandler(stepId) {
           if (this.divHandler[stepId]) {
               this.divHandler[stepId] = [];
           }
       }
   } 
}

warsApp.registerService('CustomDivService', [])